import { render, staticRenderFns } from "./bar-chart.vue?vue&type=template&id=4738983f&"
import script from "./bar-chart.vue?vue&type=script&lang=js&"
export * from "./bar-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports